import styled from 'styled-components';

import { font16 } from 'approot/shared/styles/typography.style';
import { flexLeftAlignCss } from 'approot/shared/styles/flex.style';
import { grey10 } from 'approot/shared/styles/colours.style';

export const SimpleCardLabelTitle = styled.div`
  ${font16}
  ${flexLeftAlignCss}
  color: ${grey10};
`;
